import * as actionTypes from "./actionTypes";

export const getCf3ListStart = () => {
  return {
    type: actionTypes.GET_CF3_LIST_START,
  };
};

export const getCf3ListFail = (error) => {
  return {
    type: actionTypes.GET_CF3_LIST_FAIL,
    error,
  };
};

export const getCf3List = (search, pageLimit) => {
  return {
    type: actionTypes.GET_CF3_LIST,
    search,
    pageLimit,
  };
};

export const getCf3ListSuccess = (response) => {
  return {
    type: actionTypes.GET_CF3_LIST_SUCCESS,
    response,
  };
};

export const getCf3Detail = (id) => {
  return {
    type: actionTypes.GET_CF3_DETAIL,
    id,
  };
};

export const getCf3DetailSuccess = (response) => {
  return {
    type: actionTypes.GET_CF3_DETAIL_SUCCESS,
    response,
  };
};

export const cf3StatusAction = (cf3Data) => {
  return {
    type: actionTypes.CF3_STATUS_ACTION,
    cf3Data,
  };
};
